# SCORM 1.2 documentation
# https://scorm.com/scorm-explained/technical-scorm/run-time/run-time-reference/#section-2
# SCORM 2004 documentation
# https://scorm.com/scorm-explained/technical-scorm/run-time/run-time-reference/#section-5

interactions = []
scores       = {}

track = (event, done = ->) ->

trackView = (data, done = ->) ->

trackInteraction = (data, done = ->) ->
  interactions.push(data)
  if data?.configuration?.nb_stars? or data?.configuration?.weighting?
    name   = data.name
    total  =
      if data.configuration.weighting?
        data.configuration.weighting
      else
        data.configuration.nb_stars
    earned =
      if data.game
        { max, min } = data.slideData.game.stars

        if data.configuration.weighting?
          # Calculate the scaled weighting based on score
          if data.score.total < min
            0
          else if data.score.total > max
            total
          else
            Math.floor((data.score.total - min) / ((max - min) / total))

        else
          data.nb_stars_earned
      else
        if data.correct then total else 0
    scores[name] = { earned, total }

trackScoreAndCompletion = (minScaledScore = 0, incompleteOnFail = false) ->
  version = pipwerks.SCORM.version

  _scores = (v for k, v of scores) or []
  _earned = _scores.reduce ((result, s) -> result + s.earned), 0
  _total  = _scores.reduce ((result, s) -> result + s.total), 0

  if _total is 0 or _scores.length is 0 # in case total = 0, automatically gives 100% score to avoid "Passing" with 0 scores.
    _earned = 1
    _total = 1

  _scaled = _earned * 100.0 / _total

  if version == '2004'
    # Scorm 1.4 standards specificly for SABA
    pipwerks.SCORM.set("cmi.score.raw", _earned)
    pipwerks.SCORM.set("cmi.score.min", 0)
    pipwerks.SCORM.set("cmi.score.max", _total)
  else
    pipwerks.SCORM.set("cmi.core.score.raw", _earned)
    pipwerks.SCORM.set("cmi.core.score.min", 0)
    pipwerks.SCORM.set("cmi.core.score.max", _total)

  if _total is 0 or _scores.length is 0 or _scaled >= minScaledScore
    pipwerks.SCORM.status 'set', if version == '2004' then "completed" else "passed"

  else
    failStatus = if incompleteOnFail then "incomplete" else "failed"
    pipwerks.SCORM.status 'set', if version == '2004' then 'incomplete' else failStatus

trackEvent = ->
startTracking = ->
stopTracking = ->

commands = (next) ->
  { trackInteraction,
    trackView,
    startTracking,
    stopTracking,
    trackEvent,
    trackScoreAndCompletion }

module.exports = { type: "analytics", commands }
